import { Chip, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import type { Alert } from '../../app/types';
import PageSection from '../shared/PageSection';

export default function AlertsPage({ alerts }: { alerts: Alert[] }) {
  return (
    <PageSection title="Alerts" subtitle="Open and historical alert records generated by the face-match worker.">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Camera</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Summary</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alerts.map((alert) => (
            <TableRow key={alert.alertId}>
              <TableCell>{new Date(alert.createdAt).toLocaleString()}</TableCell>
              <TableCell><Chip size="small" label={alert.status} /></TableCell>
              <TableCell>{alert.cameraId}</TableCell>
              <TableCell>{alert.subjectId}</TableCell>
              <TableCell>{alert.summary}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </PageSection>
  );
}
